import Console from './Console';
export default function Home() { return <Console />; }
